var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "grm-checkbox-container",
      class: { disabled: _vm.disabled },
    },
    [
      _c("input", {
        staticClass: "grm-checkbox",
        attrs: { type: "checkbox", id: _vm.id, name: _vm.id },
        domProps: { checked: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.checked)
          },
        },
      }),
      _c(
        "label",
        { staticClass: "grm-checkbox-label", attrs: { for: _vm.id } },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }